<template>
  <div>
    <page-title
      title="Your qualifications"
      description="Now, let’s fill in your academic credentials, as well as any professional awards and certifications."
    />

    <h2 class="mt-4 mb-5">
      <span class="font-semibold text-gray-600 text-xl">Education</span> <small class="text-gray-400">(At least one is required)</small>
    </h2>

    <step-item-card
      v-for="(item, i) in details.education_qualifications"
      :key="i"
      :title="item.degree_type"
      :from="item.start_date"
      :to="item.end_date"
      :description="`${item.school_name} ${item.country}`"
      @edit="editItem(i)"
    />

    <add-step-item-cta title="education" @click="showQualDialog = true" />

    <add-qualification
      :qualification="qualification"
      :action-type="indexToEdit ? 'update' : 'add'"
      :is-active="showQualDialog"
      @close="showQualDialog = false"
      @confirm="addQual"
    />
  </div>
</template>

<script setup>
import PageTitle from './PageTitle.vue';
import AddStepItemCta from './AddStepItemCta.vue';
import StepItemCard from './StepItemCard.vue';
import AddQualification from './AddQualification.vue';
import { ref } from 'vue';
import { alert, errorMessage } from '@/utils/helper';

const props = defineProps({
  details: {
    type: Object,
  },
});

const showQualDialog = ref(false);
const indexToEdit = ref(null);
const qualification = ref({
  school_name: '',
  school_type: 'University / College',
  degree_type: '',
  faculty_department: '',
  specialization_subjects: '',
  country: '',
  start_date: '',
  end_date: '',
  learning_mode: 'In-person learning',
  education_details: '',
});

const editItem = (index) => {
  indexToEdit.value = index;
  qualification.value = props.details.education_qualifications[index];
  showQualDialog.value = true;
};

const addQual = () => {
  const { school_name, degree_type, country, start_date, end_date, education_details } = qualification.value;
  if (!school_name || !degree_type || !start_date || !end_date || !country) return alert('Please fill all required fields', 'error');

  if (indexToEdit.value == null) {
    props.details.education_qualifications.push(qualification.value);
  } else {
    props.details.education_qualifications[indexToEdit.value] = qualification.value;
    indexToEdit.value = null;
  }

  qualification.value = {
    school_name: '',
    school_type: 'University / College',
    degree_type: '',
    faculty_department: '',
    specialization_subjects: '',
    country: '',
    start_date: '',
    end_date: '',
    learning_mode: 'In-person learning',
    education_details: '',
  };
  showQualDialog.value = false;
};
</script>
